module.exports = __webpack_public_path__ + "static/media/scribble-light-1920x1080.5eba0cd5.png";